/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * How the invitation is delivered, which drives whether an email is proven.
 * @export
 */
export const InvitationChannel = {
    Link: 'link',
    Email: 'email'
};
export function instanceOfInvitationChannel(value) {
    for (const key in InvitationChannel) {
        if (Object.prototype.hasOwnProperty.call(InvitationChannel, key)) {
            if (InvitationChannel[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function InvitationChannelFromJSON(json) {
    return InvitationChannelFromJSONTyped(json, false);
}
export function InvitationChannelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function InvitationChannelToJSON(value) {
    return value;
}
export function InvitationChannelToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
